import { ButtonTypes, LinkTypes } from '@cox/core-ui8/dist/Button'
import { useFlexOffers } from '@cox/core-ui8/dist/useFlexOffers'
import { Placeholder } from 'react-bootstrap'

import SlideInfoSkeleton from './SlideInfoSkeleton'
import { getImageSrc } from '../../../../utils/local-util'
import { getAttributeValue, getConditionResult, hasCFConditionals } from '../../../../utils/rule-builder-util'
import { RuleType } from '../../../../utils/types'
import ReactButton from '../../../ReactButton'
import ReactList, { ListType } from '../../../ReactList'
import ReactText from '../../../ReactText'
import TimerBar from '../TimeBar/TimerBar'
import { SlideInfoProps } from '../types'

const SlideInfo = (props: SlideInfoProps) => {
  const {
    elements,
    activeItem,
    handleOnClick,
    duration,
    ruleExpression = '',
    condition,
    ruleType,
    slideIndex,
    pause,
    tokenProperties,
    id = ''
  } = props
  const flexOffers = useFlexOffers(ruleExpression)

  // get value if it is dynamic, or else return value authored value
  const getValue = (attribute: any, propertyName?: string) => {
    if (hasCFConditionals(attribute)) {
      const jsonAttribute = elements?.[`${propertyName}_json`]
      return getAttributeValue(jsonAttribute, flexOffers, slideIndex, tokenProperties, propertyName)
    }
    return getAttributeValue(attribute, flexOffers, slideIndex, tokenProperties, propertyName)
  }
  if (flexOffers?.loading) {
    return <SlideInfoSkeleton id={id} duration={duration} pause={pause} activeItem={activeItem} />
  }
  // flex offers success
  let conditionResult = true
  if (flexOffers?.success && ruleType === RuleType.conditional && condition) {
    conditionResult = getConditionResult(condition, flexOffers)
  }
  if (conditionResult) {
    const {
      heading,
      description,
      bulletPoints,
      bulletIcon,
      bulletIconAltText,
      buttonTextPrimary,
      buttonLinkPrimary,
      buttonLinkNewTabPrimary,
      linkIdButtonPrimary = { value: '' },
      linkTypeButtonPrimary = { value: '' },
      contentFragmentId = { value: '' }
    } = elements
    const contentFragmentIdValue = getValue(contentFragmentId, 'contentFragmentId')
    const idValue = getValue(id, 'id')
    const slideId = contentFragmentIdValue || idValue
    const headingValue = getValue(heading, 'heading')
    const descriptionValue = getValue(description, 'description')
    const buttonTextPrimaryValue = getValue(buttonTextPrimary, 'buttonTextPrimary')
    const buttonLinkPrimaryValue = getValue(buttonLinkPrimary, 'buttonLinkPrimary')
    const buttonLinkNewTabPrimaryValue = getValue(buttonLinkNewTabPrimary, 'buttonLinkNewTabPrimary')
    const linkIdButtonPrimaryValue = getValue(linkIdButtonPrimary, 'linkIdButtonPrimary')
    const linkTypeButtonPrimaryValue = linkTypeButtonPrimary?.value

    const bulletList = {
      icon: getImageSrc(getValue(bulletIcon, 'bulletIcon')),
      altIcon: getValue(bulletIconAltText, 'bulletIconAltText'),
      items: bulletPoints?.value?.map((bullet: any) => getValue(bullet))
    }
    return (
      <div className='carousel-sidebar-slide-info' id={slideId}>
        {slideId === activeItem ? (
          <div className='carousel-item-info-container'>
            <TimerBar isActive={true} duration={duration} pause={pause} />
            <div className='carousel-item-info'>
              <div className='header' tabIndex={0} role='button'>
                {/* TODO Anchor tag is creating issue.  CCCOREUI-3410*/}
                {/* <a className='tealium-tracking-link' href='#' onClick={(e) => e.preventDefault()} tabIndex={0}> */}
                <ReactText text={headingValue} isParsed />
                {/* </a> */}
              </div>
              <div className='heading-description'>
                <ReactText text={descriptionValue} isParsed />
              </div>
              <ReactList
                listFrom={ListType.cfStandardList}
                icon={bulletList.icon}
                altIcon={bulletList.altIcon}
                cfListItems={bulletList.items}
              />
              <div className='cta-section-container large-device' key={buttonTextPrimaryValue + slideId}>
                {flexOffers?.loading ? (
                  <Placeholder.Button xs={5} variant={ButtonTypes.PRIMARY} />
                ) : (
                  <>
                    {buttonTextPrimaryValue.length > 0 && (
                      <ReactButton
                        text={buttonTextPrimaryValue}
                        linkUrl={buttonLinkPrimaryValue ?? ''}
                        openInNewTab={Boolean(buttonLinkNewTabPrimaryValue)}
                        buttonTypes={ButtonTypes.PRIMARY}
                        linkType={linkTypeButtonPrimaryValue as LinkTypes}
                        linkId={linkIdButtonPrimaryValue}
                        index={slideIndex}
                        ruleExpression={ruleExpression}
                      />
                    )}{' '}
                  </>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className='carousel-item-info-container'>
            <TimerBar isActive={false} duration={duration} pause={props.pause} />
            <div className='carousel-item-info'>
              <div
                className='header inactive'
                onClick={(e) => handleOnClick(slideId, e)}
                tabIndex={0}
                role='button'
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    handleOnClick(slideId, e)
                  }
                }}
              >
                {/* TODO Anchor tag is creating issue.  CCCOREUI-3410*/}
                {/* <a className='tealium-tracking-link' href='#' tabIndex={0} onClick={(e) => handleOnClick(id, e)}> */}
                <ReactText text={headingValue} isParsed={true} />
                {/* </a> */}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
  return <></>
}
export default SlideInfo
